/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/content/assets/profile-pic.jpg/" }) {
        publicURL
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  // const social = data.site.siteMetadata?.social

  const avatar = data?.avatar?.childImageSharp?.fixed

  return (
    <div className="bio">
      <aside id="avatar">
      {avatar && (
        <Image
          fixed={avatar}
          alt={`pic`}
          className="bio-avatar"
          imgStyle={{
            borderRadius: `50%`,
          }}
        />
      )}
      </aside>
      {author?.name && (
          <p style={{fontSize: '1.5rem'}}>
            My name is <strong>{author.name}.</strong> {author?.summary || null}
            {` `}
          </p>
      )}
    </div>
  )
}

export default Bio
